module.exports = __webpack_public_path__ + "static/supria-black-webfont-2bba4d03b8d96457a7b5d2f161382c02.woff2";